"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldSidesheetCoreInputs = void 0;
const sidesheet_type_1 = require("./sidesheet.type");
class EmeraldSidesheetCoreInputs {
    constructor() {
        this.type = sidesheet_type_1.EmeraldSidesheetType.Modal;
        this.width = sidesheet_type_1.EmeraldSidesheetWidth.Small;
        this.fixed = false;
        this.hasToolbarAttached = false;
    }
}
exports.EmeraldSidesheetCoreInputs = EmeraldSidesheetCoreInputs;
//# sourceMappingURL=sidesheet.inputs.js.map